import { render, staticRenderFns } from "./ticket-detail.vue?vue&type=template&id=7a9779c3&scoped=true"
import script from "./ticket-detail.vue?vue&type=script&lang=js"
export * from "./ticket-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9779c3",
  null
  
)

export default component.exports